import { useState } from 'react';
import MergeChatLogo from '../components/MergeChatLogo';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'เข้าสู่ระบบไม่สำเร็จ');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <MergeChatLogo size={36} />
          <span><span>Merge</span><span style={{color:'#FF6347', fontWeight:700}}>Chat</span></span>
        </div>
        <h1>เข้าสู่ระบบ</h1>
        <p className="login-sub">สำหรับ Agent ทีม Support</p>

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Username / ID</label>
            <input
              type="text"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="ใส่ Username หรือ Email"
              required
              autoComplete="username"
            />
          </div>
          <div className="field">
            <label>รหัสผ่าน</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          {error && <div className="error-msg">{error}</div>}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
          </button>
        </form>
      </div>
    </div>
  );
}
